<template>
  <div id="app">
    <Index v-show="this.$route.path!=='/'" />
    <router-view />
  </div>
</template>

<script>
import Index from '@/views/common/Index.vue'
import Login from '@/views/login/Login.vue'

export default {
  name: 'App',
  components: {
    Login,
    Index
  },
  created () {

  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue